// パターン選択コンポーネント JavaScript
// このコードを先にShopifyのテーマファイルまたはアプリで読み込んでください

console.log('パターン選択JS読み込み開始');

// グローバル関数を即座に定義
function openPatternModal() {
    console.log('openPatternModal が呼ばれました');
    
    try {
        if (!window.patternData) {
            console.error('patternDataが定義されていません');
            alert('パターンデータが読み込まれていません');
            return;
        }
        
        var titleElement = document.getElementById('pattern-modal-title');
        if (!titleElement) {
            console.error('pattern-modal-title要素が見つかりません');
            return;
        }
        titleElement.textContent = window.patternData.title;
        
        var optionsContainer = document.getElementById('pattern-options');
        if (!optionsContainer) {
            console.error('pattern-options要素が見つかりません');
            return;
        }
        
        optionsContainer.innerHTML = '';
        
        for (var i = 0; i < window.patternData.options.length; i++) {
            var option = window.patternData.options[i];
            var optionElement = document.createElement('div');
            optionElement.className = 'pattern-option';
            optionElement.setAttribute('data-option-id', option.id);
            
            // クロージャーでイベントハンドラーを作成
            (function(opt, elem) {
                elem.onclick = function() {
                    selectPatternOption(elem, opt);
                };
            })(option, optionElement);
            
            optionElement.innerHTML = 
                '<img src="' + option.image + '" alt="' + option.name + '" class="pattern-image" onerror="this.src=\'https://via.placeholder.com/200x120/f0f0f0/999?text=画像なし\'">' +
                '<div class="pattern-name">' + option.name + '</div>' +
                '<div class="pattern-description">' + option.description + '</div>';
            
            optionsContainer.appendChild(optionElement);
        }
        
        var modal = document.getElementById('pattern-modal-overlay');
        if (modal) {
            modal.style.display = 'block';
            document.body.style.overflow = 'hidden';
        }
    } catch (error) {
        console.error('モーダル表示エラー:', error);
        alert('エラーが発生しました: ' + error.message);
    }
}

function closePatternModal() {
    console.log('closePatternModal が呼ばれました');
    var modal = document.getElementById('pattern-modal-overlay');
    if (modal) {
        modal.style.display = 'none';
    }
    document.body.style.overflow = 'auto';
    window.selectedOption = null;
    
    var options = document.querySelectorAll('.pattern-option');
    for (var i = 0; i < options.length; i++) {
        options[i].classList.remove('selected');
    }
}

function confirmPatternSelection() {
    console.log('confirmPatternSelection が呼ばれました');
    if (!window.selectedOption) {
        alert('パターンを選択してください');
        return;
    }
    
    var valueElement = document.getElementById('pattern-value');
    if (valueElement) {
        valueElement.textContent = window.selectedOption.name;
        valueElement.classList.add('has-value');
    }
    
    var propertyField = document.getElementById('pattern-property');
    if (propertyField) {
        propertyField.value = window.selectedOption.name;
    }
    
    closePatternModal();
}

function selectPatternOption(element, option) {
    console.log('パターン選択:', option.name);
    var allOptions = document.querySelectorAll('.pattern-option');
    for (var i = 0; i < allOptions.length; i++) {
        allOptions[i].classList.remove('selected');
    }
    element.classList.add('selected');
    window.selectedOption = option;
}

// デフォルトパターンデータ
window.patternData = {
    title: '硬さパターンを選択',
    options: [
        {
            id: 'pattern-v1',
            name: 'パターンV1',
            description: 'パターンV1',
            image: 'https://via.placeholder.com/200x120/e3f2fd/1976d2?text=V1'
        },
        {
            id: 'pattern-v2',
            name: 'パターンV2',
            description: 'パターンV2',
            image: 'https://via.placeholder.com/200x120/f3e5f5/7b1fa2?text=V2'
        },
        {
            id: 'pattern-v3',
            name: 'パターンV3',
            description: 'パターンV3',
            image: 'https://via.placeholder.com/200x120/e8f5e8/388e3c?text=V3'
        },
        {
            id: 'pattern-v4',
            name: 'パターンV4',
            description: 'パターンV4',
            image: 'https://via.placeholder.com/200x120/fff3e0/f57c00?text=V4'
        },
        {
            id: 'pattern-v5',
            name: 'パターンV5',
            description: 'パターンV5',
            image: 'https://via.placeholder.com/200x120/fce4ec/e91e63?text=V5'
        }
    ]
};
window.selectedOption = null;

// メタオブジェクトからデータを読み込む関数
function loadPatternData() {
    console.log('メタオブジェクトデータ読み込み開始');
    
    try {
        var patterns = [];
        var patternHandles = ['pattern-v1', 'pattern-v2', 'pattern-v3', 'pattern-v4', 'pattern-v5'];
        
        for (var i = 0; i < patternHandles.length; i++) {
            var handle = patternHandles[i];
            var datasetKey = handle.replace('-', '');
            var element = document.querySelector('[data-' + handle + ']');
            if (element && element.dataset[datasetKey] && element.dataset[datasetKey] !== 'null') {
                try {
                    var metaData = JSON.parse(element.dataset[datasetKey]);
                    if (metaData && metaData.name) {
                        patterns.push({
                            id: handle,
                            name: metaData.name,
                            description: metaData.description || metaData.name,
                            image: metaData.img ? (metaData.img.url || metaData.img) : 'https://via.placeholder.com/200x120/f0f0f0/999?text=' + metaData.name
                        });
                    }
                } catch (parseError) {
                    console.log(handle + 'の解析に失敗:', parseError);
                }
            }
        }

        if (patterns.length > 0) {
            window.patternData = {
                title: '硬さパターンを選択',
                options: patterns
            };
            console.log('メタオブジェクトから読み込み完了:', patterns.length, '個のパターン');
        } else {
            console.log('メタオブジェクトデータが見つかりません、デフォルト設定を使用');
        }
    } catch (error) {
        console.log('メタオブジェクトからの読み込みに失敗、デフォルト設定を使用:', error);
    }
}

// イベントリスナー設定
function setupPatternModalEvents() {
    var overlay = document.getElementById('pattern-modal-overlay');
    if (overlay) {
        overlay.addEventListener('click', function(e) {
            if (e.target === overlay) {
                closePatternModal();
            }
        });
    }

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            var modal = document.getElementById('pattern-modal-overlay');
            if (modal && modal.style.display === 'block') {
                closePatternModal();
            }
        }
    });
}

// 初期化関数
function initPatternSelector() {
    console.log('パターン選択初期化開始');
    loadPatternData();
    setupPatternModalEvents();
    console.log('パターン選択初期化完了');
}

// DOMが準備できたら初期化（自動実行しない、必要に応じて呼び出し）
if (typeof window.patternSelectorAutoInit === 'undefined' || window.patternSelectorAutoInit) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPatternSelector);
    } else {
        // 少し待ってから実行（他の要素が読み込まれるのを待つ）
        setTimeout(initPatternSelector, 100);
    }
}

console.log('パターン選択JS読み込み完了 - 関数定義済み');